<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YDHFR5/tc-custom/9781440550119.jpg?1730528476886" alt="This image is the cover for the book Only Budgeting Book You'll Ever Need"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Only Budgeting Book You'll Ever Need
      </h1>
      <p class="bookDescription body article font2">
        <b>Create a foolproof budget that's right for you!</b><br/><br/>Everyone wants a simple and practical way to manage their money, but with countless financial planners, budgeting articles, and websites available, it's not always easy to figure out where to start. Filled with only the most essential information on budgeting, this book shows you how to build a financial plan that not only meets your needs, but helps you stay on track.<br/><br/>From prioritizing goals and listing expenses to saving regularly and planning for future finances, this book guides you through all the important steps of budgeting with realistic advice. You'll be able to create a visual portrait of your finances as well as learn how to manage your spending, stay out of debt, and build for the future. This book also includes a resource guide for free and up-to-date web tools that make the process as easy and comprehensive as possible.<br/><br/>With <i>The Only Budgeting Book You'll Ever Need</i>, you will finally be able to find peace of mind knowing that you can create a realistic budget that works for your financial situation and goals.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tere Stouffer
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c7d0126